import type { AgentDto, LlmModelDto, LlmProviderDto } from '@shared/services/apiService/apiService';

/**
 * Pure display helpers for LLM-related titles. No hooks here.
 */

export function resolveProviderTitle(
  row: AgentDto,
  providers?: LlmProviderDto[] | null,
  t?: (key: string) => string,
): string {
  if (row.llmProvider?.title) return row.llmProvider.title;
  const title = providers?.find((p) => p.id === row.llmProviderId)?.title;
  if (title) return title;
  return t ? t('adminMainPage.agents.unknownProvider') : 'Unknown provider';
}

export function resolveModelTitle(
  row: AgentDto,
  provider?: LlmProviderDto | null,
  providerModels?: LlmModelDto[] | null,
  t?: (key: string) => string,
): string {
  // If provider allows custom models, always prefer custom key
  if (row.llmCustomModelKey) return row.llmCustomModelKey;

  // If relation already present with a title
  if (row.llmModel?.title) return row.llmModel.title;

  // If provider allows custom models but no custom key set
  if (provider?.allowsCustomModels) {
    return t ? t('adminMainPage.agents.unknownModel') : 'Unknown model';
  }

  // Otherwise resolve from provider model list
  if (providerModels && row.llmModelId) {
    const title = providerModels.find((m) => m.id === row.llmModelId)?.title;
    if (title) return title;
  }

  return t ? t('adminMainPage.agents.unknownModel') : 'Unknown model';
}
